import Anchor from "atoms/anchors/anchor";
import { IconSizes } from "atoms/constants/icon-sizes";
import { Icons } from "atoms/constants/icons";
import { ParagraphSizes } from "atoms/constants/paragraph-sizes";
import Icon from "atoms/icons/icon";
import Paragraph from "atoms/typography/paragraph";
import UnorderedList from "molecules/lists/unordered-list";
import React from "react";
import { CollectionUtils } from "utilities/collection-utils";
import { useLocalization } from "utilities/hooks/use-localization";
import useTeams from "utilities/hooks/use-teams";

// -----------------------------------------------------------------------------------------
// #region Interfaces
// -----------------------------------------------------------------------------------------

// #endregion Interfaces

// -----------------------------------------------------------------------------------------
// #region Constants
// -----------------------------------------------------------------------------------------

const BASE_CLASS = "c-subscription-detail-card";

// #endregion Constants

// -----------------------------------------------------------------------------------------
// #region Component
// -----------------------------------------------------------------------------------------

const SubscriptionDetailCardTeamAdmins: React.FC = () => {
    const { t } = useLocalization();

    const { teamAdmins } = useTeams();

    return (
        <>
            {CollectionUtils.hasValues(teamAdmins) && (
                <div className={`${BASE_CLASS}__admins`}>
                    <div className={`${BASE_CLASS}__admins__icon`}>
                        <Icon
                            size={IconSizes.Large}
                            type={Icons.NoteColorable}
                            cssClassName={`${BASE_CLASS}__admins__svg`}
                        />
                        <span className={`${BASE_CLASS}__admins__title`}>
                            {t("teamAdministrators")}
                        </span>
                    </div>
                    <Paragraph size={ParagraphSizes.Small}>
                        {t("reachOutToAccountAdministratorsMessage")}
                    </Paragraph>
                    <UnorderedList
                        listItems={teamAdmins.map((admin) => (
                            <Paragraph
                                size={ParagraphSizes.Small}
                                cssClassName={`${BASE_CLASS}__admins__entry`}>
                                <span className={`${BASE_CLASS}__admins__name`}>
                                    {admin.getFirstAndLastName()}
                                </span>
                                <br />
                                <span
                                    className={`${BASE_CLASS}__admins__email`}>
                                    <Anchor
                                        external
                                        to={`mailto:${admin.email}`}>
                                        {admin.email}
                                    </Anchor>
                                </span>
                            </Paragraph>
                        ))}
                    />
                </div>
            )}
        </>
    );
};

// #endregion Component

// -----------------------------------------------------------------------------------------
// #region Exports
// -----------------------------------------------------------------------------------------

export default SubscriptionDetailCardTeamAdmins;

// #endregion Exports
